/* eslint-disable react/react-in-jsx-scope */
import { JSX, useContext } from 'react';
import StyledPromptContainer from '../../styles/StyledPromptContainer';
import PromptFooter from '../PromptFooter/PromptFooter';
import PromptForm from '../PromptForm/PromptForm';
import AppContextType from '../../types/AppContextType';
import AppContext from '../../contexts/AppContext';

interface PromptProps {
  disabled: boolean;
  showRating: boolean;
}

const Prompt = ({ disabled, showRating }: PromptProps): JSX.Element => {
  const { configuration } = useContext<AppContextType>(AppContext);

  return (
    <>
      <StyledPromptContainer>
        <PromptForm showRating={showRating} disabled={disabled} />
      </StyledPromptContainer>
      <PromptFooter whiteLabeled={configuration?.white_labeled} />
    </>
  );
};

export default Prompt;
